import(/* webpackMode: "eager" */ "/app/src/app/[locale]/industry/page.tsx");
